<span
	class="badge"
	[ngClass]="{
      'badge-secondary': state === DeliveryState.NEW,
      'badge-success': state === DeliveryState.COMPLETED,
      'badge-warning': state === DeliveryState.DELIVERED
    }"
>{{ 'delivery.states.' + workflow + '.' + state | translate }}</span
>
